<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("omnicloud_fr.face.watch_list") }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="watchlistFilter"
            :options="watchlistOptions"
            label="label"
            class="w-100"
            :multiple="false"
            :reduce="(val) => val.label"
            @input="(val) => $emit('update:watchlistFilter', val)"
            append-to-body
            :calculate-position="withPopper"
          />
      </b-col>
      <b-col cols="6" md="6" class="mb-md-0 mb-2">
        <b-form-group>
          <label class="text-capitalize">
            {{ $t("date.created_at") }}
          </label>
          <flat-pickr
            class="form-control"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i:s',
              time_24hr: true,
            }"
            :value="startDate"
            @on-change="(selectedDates, val) => $emit('update:startDate', val)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" md="6" class="mb-md-0 mb-2">
        <b-form-group>
          <label class="text-capitalize">
            {{ $t("date.updated_at") }}
          </label>
          <flat-pickr
            class="form-control"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i:s',
              time_24hr: true,
            }"
            :value="endDate"
            @on-change="(selectedDates, val) => $emit('update:endDate', val)"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from '@/libs/popper-helper';
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    watchlistOptions: {
      type: Array,
      default: null,
    },
    watchlistFilter: {
      type: String,
      default: null,
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
